import React, {useState} from 'react';
import {FormikHelpers} from 'formik';

import {Form, Button, Modal} from '@components';
import mappings from '@mappings';
import {Props} from './types';

import * as handlers from './handlers';
import * as hooks from './hooks';

import './index.scss';

const Edit: React.FC<Props> = props => {
  const [isModal, setIsModal] = useState(false);
  const initialValues = {
    firstName: props.users.detail.firstName,
    lastName: props.users.detail.lastName,
    lastKana: props.users.detail.lastKana,
    firstKana: props.users.detail.firstKana,
    email: props.users.detail.email,
    phoneNumber: props.users.detail.phoneNumber,
    prefecture: props.users.detail.prefecture,
    authLevel: props.users.detail.authLevel,
    teamId: props.me.teamId,
  };

  hooks.useMount({...props}, props.actions);

  return (
    <div className="a__admin-edit">
      <div className="b__title">特権管理者編集</div>
      <div className="b__main">
        <div className="w__edit-field">
          <div className="w__information-field">
            <Form.User
              handleSubmit={(values: any, formikHelpers: FormikHelpers<any>) =>
                handlers.update(
                  values,
                  formikHelpers,
                  props.actions,
                  props.match.params.id
                )
              }
              initialValues={initialValues}
              me={props.me}
              users={props.users}
              submitText="編集する"
            />
          </div>
        </div>
        <div className="w__side-buttons">
          <Button.Normal
            text="特権管理者を削除する"
            onClick={() => setIsModal(true)}
            color="red"
            className="b__delete"
            disabled={
              props.users.detail.authLevel === mappings.authorities[2].value
            }
          />
          <Button.Normal
            text="前のページに戻る"
            onClick={() => props.history.goBack()}
          />
        </div>
      </div>
      <Modal.Delete
        handleCloseModal={setIsModal}
        title="特権管理者を削除"
        isModal={isModal}
        onClick={() => {
          handlers.deleteUser(props, props.match.params.id);
        }}
        message={
          <>
            <div>
              {`${props.users.detail.lastName}${props.users.detail.firstName}`}
              さんを特権管理者一覧から削除しますか？
            </div>
            <div>
              削除するとユーザー一覧から削除され、 ログインできなくなります。
            </div>
          </>
        }
      />
    </div>
  );
};

export default Edit;
